import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

interface PayrollWorker {
  name: string;
  dailyHours: Record<string, number>;
  totalHours: number;
}

interface PayrollSummaryTableProps {
  workers: PayrollWorker[];
  dates: string[];
  dateTotals: Record<string, number>;
}

export function PayrollSummaryTable({
  workers,
  dates,
  dateTotals,
}: PayrollSummaryTableProps) {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-xl font-bold mb-4">Payroll Summary</h2>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="font-bold">Worker Name</TableHead>
              {dates.map((date) => (
                <TableHead key={date} className="text-center">
                  {date.slice(5).replace('-', '/')}
                </TableHead>
              ))}
              <TableHead className="text-center font-bold">Total</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {workers.map((worker) => (
              <TableRow key={worker.name}>
                <TableCell className="font-medium">{worker.name}</TableCell>
                {dates.map((date) => (
                  <TableCell key={date} className="text-center">
                    {worker.dailyHours[date] || 0}
                  </TableCell>
                ))}
                <TableCell className="text-center font-bold">
                  {worker.totalHours.toFixed(2)}
                </TableCell>
              </TableRow>
            ))}
            <TableRow className="bg-gray-50 font-bold">
              <TableCell>Daily Totals</TableCell>
              {dates.map((date) => (
                <TableCell key={date} className="text-center">
                  {dateTotals[date]?.toFixed(2) || '0.00'}
                </TableCell>
              ))}
              <TableCell className="text-center">
                {Object.values(dateTotals).reduce((sum, val) => sum + val, 0).toFixed(2)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
